import { type HttpErrorResponse } from '@angular/common/http';
import { type IncidentDto } from '@api/incidents';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const IncidentsActions = createActionGroup({
  events: {
    'Add Incident': props<{ incident: IncidentDto; }>(),
    'Load All Incident Error': props<{ error: HttpErrorResponse; }>(),
    'Load All Incident Success': props<{ incidents: IncidentDto[]; }>(),
    'Load All Incidents': emptyProps(),
    'Reset Incidents': emptyProps(),
    'Resolve Incidents': props<{ incidents: IncidentDto[]; }>(),
  },
  source: 'Incidents',
});
